import { mapActions } from 'vuex'
/**
 * This is a mixin that adds some default logging to states. When a state is first loaded
 * the ENTERED event is logged. When the state is being left a TRANSITION action is logged.
 */
const State = {
  // mounted () {
  //   this.log({ action_type: 'ENTERED', payload: { page: this.$route.name } })
  // },
  // beforeDestroy () {
  //   this.log({ action_type: 'TRANSITION', payload: { page: this.$route.name } })
  // },
  // methods: { ...mapActions(['log']) }
}
export default State
